module.exports = __webpack_public_path__ + "static/media/leads.2db0b815.svg";